export default __webpack_public_path__ + "static/media/ahmed razon.28ad8311.png";